import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import uuidv4 from 'uuid/v4'

import { useOutsideClick } from 'hooks'
import { Flex, HR, P, RadioButton } from 'ui/bend'

import { CloseButton } from 'ui/bend'

import { AUTO_BITRATE, useVideoPlayerContext } from './VideoPlayerContext'

const Container = styled(Flex)`
  position: absolute;
  flex-direction: column;
  min-width: 256px;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: ${(props) => props.theme.colors.base};
  transform: ${(props) => (props.show ? 'translateX(0)' : 'translateX(100%)')};
  opacity: ${(props) => (props.show ? '1' : '0')};
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06),
    0px 8px 16px rgba(35, 41, 54, 0.08);
  overflow: auto;
`

const RadioButtonContainer = styled(Flex)`
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  flex-direction: column;
`

const SettingsPopup = () => {
  const { state, actions } = useVideoPlayerContext()
  const [uuid] = useState(() => uuidv4()) // we need a unique id for each settings popup, as some pages render videoContext multiple times.
  const ref = useRef()

  useOutsideClick(ref, actions.toggleSettings, state.showSettings)

  /* Prevent user from selecting vjs-control-bar while menu is open */
  useEffect(() => {
    const controlBar = document.getElementsByClassName('vjs-control-bar')[0]
    // useKeyboardTrap_Dangerous() is not working for some reason - focus is being set on document.body and not trapped.
    if (state.showSettings) {
      if (controlBar) {
        controlBar.setAttribute('aria-hidden', true)
      }
    } else {
      if (controlBar) {
        controlBar.setAttribute('aria-hidden', false)
      }
    }
  }, [state.showSettings])

  return (
    <Container ref={ref} show={state.showSettings}>
      <Flex justifyContent='space-between' alignItems='center' p='24px'>
        <P as='div'>Select Quality</P>
        <CloseButton
          onClick={actions.toggleSettings}
          variant='dim'
          id='close-settings-menu'
        />
      </Flex>
      <HR />
      <RadioButtonContainer>
        <RadioButton
          id={`resolution-selection-${uuid}-auto`}
          value={-1}
          name={`resolution-selection-${uuid}`}
          checked={state.currentBitrate === AUTO_BITRATE}
          onChange={() => actions.setBitrate(AUTO_BITRATE)}
        >
          <P as='div'>{state.resolutions[0].resolution} (auto)</P>
        </RadioButton>
        <HR mb='16px' />
        {state.resolutions.map((resolution, index) => (
          <Fragment key={resolution.bitrate}>
            <RadioButton
              id={`resolution-selection-${uuid}-${index}`}
              value={index}
              name={`resolution-selection-${uuid}`}
              checked={resolution.bitrate === state.currentBitrate}
              onChange={() => actions.setBitrate(resolution.bitrate)}
            >
              <P as='div'>{resolution.resolution}</P>
            </RadioButton>
            <HR mb='16px' />
          </Fragment>
        ))}
      </RadioButtonContainer>
    </Container>
  )
}

export default SettingsPopup
